<mj-page-layout>
    <ra-person-profile />
</mj-page-layout>
